/* eslint-disable react-hooks/rules-of-hooks */

/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable max-len */
import { Form, Row } from 'antd';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import { ILeiData, ILeiMatka, ILeiSubory } from 'types/leiTypes';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import InputNumberComponent from 'components/atoms/InputNumberComponent';
import InputTextArea from 'components/atoms/InputTextArea';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import UploadComponent, { IFileList } from 'components/atoms/UploadComponent';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import { IcisStaty } from 'services/cisStaty';
import fileDownload from 'services/fileDownload';
import checkIcApi from 'services/lei/checkIC';
import checkLeiApi from 'services/lei/checkLEI';
import prepareFile from 'services/lei/fileDownload';

import { EAnoNe } from 'enums/anoNe';
import { EPeriodType, ETypDatMatky, ETypMatky, ETypZadostiLei } from 'enums/lei/leiDataEnums';
import { EMatNemaDuvod } from 'enums/lei/matNemaDuvod';
import { EMaterskaSpol } from 'enums/lei/materskaSpol';
import { ENotificationType } from 'enums/notificationType';

import anoNe from 'data/codebooks/anoNeSelect';
import { leiKonsolidaceSouborySelect } from 'data/codebooks/lei/leiKonsolidaceSouborySelect';
import {
    leiKonsolidaceTypSelect,
    leiKonsolidaceTypSelectAlt,
    leiKonsolidaceTypSelectAltGov
} from 'data/codebooks/lei/leiKonsolidaceTypSelect';
import { leiMaMaterskouSpolPrimaSelect } from 'data/codebooks/lei/leiMaMaterskouSpolSelect';
import { leiMatNelzeDuvodSelect } from 'data/codebooks/lei/leiMatNelzeDuvodSelect';
import { leiMatNemaDuvodSelect } from 'data/codebooks/lei/leiMatNemaDuvodSelect';
import { leiRejstrikyPermanent, leiRejstrikySelect } from 'data/codebooks/lei/leiRejstrikySelect';

import { _getKeyValue_ } from 'utils/getObjectKeyValue';
import leiRejstrikValidation from 'utils/validations/leiRejstrikValidation';
import leiValidation from 'utils/validations/leiValidation';
import { procentaValidation } from 'utils/validations/procentaValidation';

import FinalniMatka from './FinalniMatka';

interface IPrimaMatka {
    nextStep: () => void;
    prevStep: () => void;
    cisStaty: IcisStaty[];
    setFormData: React.Dispatch<React.SetStateAction<ILeiData | undefined>>;
    primaMatkaData?: ILeiMatka[];
    finalniMatkaData?: ILeiMatka[];
    internationalMatka?: ILeiMatka[];
    isEdit?: boolean;
    typZadosti?: ETypZadostiLei;
    icoSpolecnosti?: string;
}

const PrimaMatka: React.FC<IPrimaMatka> = ({
    prevStep,
    nextStep,
    setFormData,
    primaMatkaData,
    finalniMatkaData,
    internationalMatka,
    typZadosti,
    icoSpolecnosti,
    isEdit,
    cisStaty
}) => {
    const { lei, NotificationComponent, language } = useContext(Context);
    const [form] = Form.useForm();
    const [showDefaultValues, setShowDefaultValues] = useState<{ registrationauthorityid: boolean }>({
        registrationauthorityid: true
    });
    const [leiCheckLoading, setLeiCheckLoading] = useState<boolean>(false);
    const [leiCheckError, setLeiCheckError] = useState<string>('');
    const [finalniMatSubmitData, setFinalniMatSubmitdata] = useState<ILeiMatka>();
    const [disableDownload, setDisableDownload] = useState<boolean>(false);
    const [showFinalniMatka, setShowFinalniMatka] = useState<boolean>(false);
    const [errorLei, setErrorLei] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [fileList, setFileList] = useState<IFileList[] | undefined>(
        (primaMatkaData?.length
            ? primaMatkaData[0].informacekmatce?.soubory
                ? primaMatkaData[0].informacekmatce.soubory
                : []
            : []
        ).map((e, i) => {
            return {
                uid: String(i),
                name: e.orignazev ? e.orignazev : 'bez nazvu',
                fileName: e.tempnazev ? e.tempnazev : 'a',
                type: e.orignazev ? e.orignazev.split('.').slice(-1)[0] : '',
                size: 0,
                status: 'done'
            };
        })
    );
    const [prilozeneSoubory, setPrilozeneSoubory] = useState<ILeiSubory[]>(
        primaMatkaData?.length
            ? primaMatkaData[0].informacekmatce?.soubory
                ? primaMatkaData[0].informacekmatce.soubory
                : []
            : []
    );
    const [uploading, setUploading] = useState<boolean>(false);
    /* const hqLangValues = primaMatkaData?.length
        ? primaMatkaData[0].matkabezlei?.adresy &&
          primaMatkaData[0].matkabezlei.adresy.filter(e => e.typadresy === ETypAdresy.HEADQUARTERSADDRES)
        : undefined; */
    const primaMatkaDates = {
        accounting: primaMatkaData?.length
            ? primaMatkaData[0].informacekmatce &&
              primaMatkaData[0].informacekmatce.relationshipperiod?.filter(
                  e => e.periodtype === EPeriodType.ACCOUNTING_PERIOD
              )[0]
            : undefined,
        document: primaMatkaData?.length
            ? primaMatkaData[0].informacekmatce &&
              primaMatkaData[0].informacekmatce.relationshipperiod?.filter(
                  e => e.periodtype === EPeriodType.DOCUMENT_FILING_PERIOD
              )[0]
            : undefined,
        relationship: primaMatkaData?.length
            ? primaMatkaData[0].informacekmatce &&
              primaMatkaData[0].informacekmatce.relationshipperiod?.filter(
                  e => e.periodtype === EPeriodType.RELATIONSHIP_PERIOD
              )[0]
            : undefined
    };

    const [rerenderValidate, setRerenderValidate] = useState<boolean>(false);
    const [entityCheckErr, setEntityCheckErr] = useState<'shodneico' | 'existuje' | ''>('');
    const [rerenderVal, setForceRerender] = useState<boolean>(false);
    const rerender = (validateAfter?: boolean) => {
        if (validateAfter) {
            setRerenderValidate(true);
        } else {
            setForceRerender(val => !val);
        }
    };

    console.log(internationalMatka, primaMatkaData);

    useEffect(() => {
        if (rerenderValidate) {
            form.validateFields(['registrationauthorityentityid']);
            setRerenderValidate(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rerenderValidate]);

    useEffect(() => {
        //  finalniMatkaData?.length &&
        //  !(primaMatkaData?.length && primaMatkaData[0].matkabezlei) &&
        // form.getFieldValue('stav') === EMaterskaSpol.NE &&
        //  form.getFieldValue('duvod') !== 'NON_PUBLIC' &&
        // setShowFinalniMatka(true);
        (showFinalniMatka ||
            (form.getFieldValue('stav') === EMaterskaSpol.NE && form.getFieldValue('duvod') === 'NON_PUBLIC')) &&
            form.submit();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalniMatSubmitData]);

    useEffect(() => {
        form.setFieldsValue({
            duvod: primaMatkaData?.length
                ? primaMatkaData[0].duvod
                : typZadosti === ETypZadostiLei.SOLE_PROPRIETOR
                  ? EMatNemaDuvod.NON_CONSOLIDATING
                  : undefined,
            malei: primaMatkaData?.length
                ? primaMatkaData[0].matkaslei
                    ? 'ano'
                    : primaMatkaData[0].matkabezlei && 'ne'
                : undefined,
            validationdocuments: primaMatkaData?.length
                ? primaMatkaData[0].informacekmatce?.validationdocuments
                : undefined,
            jurisdikce: primaMatkaData?.length ? primaMatkaData[0].matkabezlei?.jurisdikce : undefined,
            registrationauthorityid: primaMatkaData?.length
                ? primaMatkaData[0].matkabezlei?.registrationauthorityid
                : undefined,
            relationship: primaMatkaDates.relationship?.startdate
                ? dayjs(primaMatkaDates.relationship?.startdate)
                : undefined
        });
        primaMatkaData?.length && primaMatkaData[0].matkaslei && form.validateFields(['matkaslei']);
        //    primaMatkaData?.length && primaMatkaData[0].stav === EMaterskaSpol.ANO && !isEdit && setShowFinalniMatka(true);
        setTimeout(() => rerender(), 0); // rerender po nastaveni default values (inak sa niektore nezobrazia)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any, saveOnly?: ILeiSubory[]) => {
        const formDataMatkaObj = {
            typmatky:
                typZadosti === ETypZadostiLei.BRANCH
                    ? ETypMatky.IS_INTERNATIONAL_BRANCH_OF
                    : ETypMatky.IS_DIRECTLY_CONSOLIDATED_BY,
            stav: fieldsValue.stav,
            ...(fieldsValue.duvod && {
                duvod: fieldsValue.duvod
            }),
            ...(fieldsValue.exceptionreference && {
                exceptionreference: fieldsValue.exceptionreference
            }),
            ...(fieldsValue.matkaslei && {
                matkaslei: fieldsValue.matkaslei
            }),
            ...(fieldsValue.malei === EAnoNe.NE && {
                matkabezlei: {
                    jurisdikce: fieldsValue.jurisdikce,
                    registrationauthorityid: fieldsValue.registrationauthorityid,
                    ...(fieldsValue.otherregistrationauthorityid && {
                        otherregistrationauthorityid: fieldsValue.otherregistrationauthorityid
                    }),
                    registrationauthorityentityid: fieldsValue.registrationauthorityentityid
                }
            }),
            ...(fieldsValue.malei &&
                fieldsValue.malei !== EAnoNe.NE && {
                    informacekmatce: {
                        ...(fieldsValue.relationship && {
                            datumodkdyplatnost:
                                isEdit &&
                                primaMatkaData?.length &&
                                primaMatkaData[0].informacekmatce?.datumodkdyplatnost
                                    ? primaMatkaData[0].informacekmatce?.datumodkdyplatnost
                                    : dayjs().format('YYYY-MM-DD')
                        }),
                        konsolidace: fieldsValue.konsolidace,
                        podilspolecnosti: fieldsValue.podilspolecnosti,
                        soubory: saveOnly || prilozeneSoubory,
                        validationdocuments: fieldsValue.validationdocuments,
                        ...(fieldsValue.validationreference && {
                            validationreference: fieldsValue.validationreference
                        }),
                        relationshipperiod: [
                            ...(fieldsValue.accountingstart
                                ? [
                                      {
                                          periodtype: EPeriodType.ACCOUNTING_PERIOD,
                                          startdate: fieldsValue.accountingstart.format('YYYY-MM-DD'),
                                          ...(fieldsValue.accountingend && {
                                              enddate: fieldsValue.accountingend.format('YYYY-MM-DD')
                                          })
                                      }
                                  ]
                                : []),
                            ...(fieldsValue.documentstart
                                ? [
                                      {
                                          periodtype: EPeriodType.DOCUMENT_FILING_PERIOD,
                                          startdate: fieldsValue.documentstart.format('YYYY-MM-DD'),
                                          ...(fieldsValue.documentend && {
                                              enddate: fieldsValue.documentend.format('YYYY-MM-DD')
                                          })
                                      }
                                  ]
                                : []),
                            ...(fieldsValue.relationship
                                ? [
                                      {
                                          periodtype: EPeriodType.RELATIONSHIP_PERIOD,
                                          startdate: fieldsValue.relationship.format('YYYY-MM-DD')
                                      }
                                  ]
                                : [])
                        ]
                    }
                })
        };

        const submitFunc = (finalni?: boolean) => {
            setFormData(pv => {
                return typZadosti === ETypZadostiLei.BRANCH // submit pre international matku
                    ? {
                          ...pv,
                          matky: [formDataMatkaObj]
                      }
                    : // submit pre primou a filani matku
                      {
                          ...pv,
                          matky: [
                              ...(pv && pv.matky && pv.matky.length > 0
                                  ? pv.matky.filter(
                                        e =>
                                            e.typmatky !== ETypMatky.IS_DIRECTLY_CONSOLIDATED_BY &&
                                            e.typmatky !== ETypMatky.IS_ULTIMATELY_CONSOLIDATED_BY
                                    )
                                  : []),
                              formDataMatkaObj,
                              ...(finalniMatSubmitData?.stav
                                  ? [
                                        finalni
                                            ? {
                                                  ...finalniMatSubmitData,
                                                  matkabezlei: {
                                                      ...finalniMatSubmitData.matkabezlei
                                                  }
                                              }
                                            : finalniMatSubmitData
                                    ]
                                  : !showFinalniMatka && // prenesie stare data finalni matky ak sa jej stav !== ne
                                      finalniMatkaData &&
                                      finalniMatkaData[0]?.stav &&
                                      fieldsValue.stav === EMaterskaSpol.ANO &&
                                      finalniMatkaData[0]?.stav !== EMaterskaSpol.NE
                                    ? finalniMatkaData[0]?.stav === EMaterskaSpol.ANO_SAME
                                        ? [
                                              {
                                                  ...formDataMatkaObj,
                                                  typmatky: ETypMatky.IS_ULTIMATELY_CONSOLIDATED_BY,
                                                  stav: EMaterskaSpol.ANO_SAME
                                              }
                                          ]
                                        : finalniMatkaData || []
                                    : fieldsValue.stav === EMaterskaSpol.NE &&
                                        fieldsValue.duvod !== EMatNemaDuvod.NON_PUBLIC
                                      ? [
                                            {
                                                ...formDataMatkaObj,
                                                typmatky: ETypMatky.IS_ULTIMATELY_CONSOLIDATED_BY
                                            }
                                        ]
                                      : [])
                          ] /* .filter(
                              e =>
                                  !(
                                      fieldsValue.stav === EMaterskaSpol.ANO &&
                                      e.stav === EMaterskaSpol.NE &&
                                      e.typmatky === ETypMatky.IS_ULTIMATELY_CONSOLIDATED_BY
                                  )
                          )*/
                      };
            });

            if (
                !saveOnly &&
                (showFinalniMatka || fieldsValue.stav === EMaterskaSpol.NE || typZadosti === ETypZadostiLei.BRANCH)
            ) {
                nextStep();
            } else if (!showFinalniMatka && !saveOnly) {
                setShowFinalniMatka(true);
                document.getElementById('finalniMatka')?.scrollIntoView();
            }
        };
        const currentSubmitData =
            finalniMatSubmitData && showFinalniMatka
                ? {
                      ...(finalniMatSubmitData.matkabezlei ? finalniMatSubmitData.matkabezlei : []),
                      stav: finalniMatSubmitData.stav
                  }
                : fieldsValue;
        !saveOnly &&
            (currentSubmitData.malei === EAnoNe.NE || currentSubmitData.jurisdikce
                ? icoSpolecnosti === currentSubmitData.registrationauthorityentityid
                    ? setEntityCheckErr('shodneico')
                    : (setLoading(true),
                      checkIcApi({
                          jurisdikce: currentSubmitData.jurisdikce,
                          registrationauthorityid: currentSubmitData.registrationauthorityid,
                          otherregistrationauthorityid: currentSubmitData.otherregistrationauthorityid,
                          registrationauthorityentityid: currentSubmitData.registrationauthorityentityid,
                          typzadosti: typZadosti
                      }).then(resp => {
                          if (resp.lei) {
                              setEntityCheckErr('existuje');
                              setErrorLei(resp.lei);
                          } else {
                              setEntityCheckErr('');
                              showFinalniMatka ? submitFunc(true) : submitFunc();
                          }
                      })).finally(() => setLoading(false))
                : submitFunc());
        saveOnly && submitFunc();
    };

    const uploadProps = {
        ...(isEdit && {
            extramessage: disableDownload ? 'LEI_UPLOAD_FILLIN' : '',
            onButtonClick: () => {
                form.validateFields(
                    Object.keys(form.getFieldsValue()).filter((o: any) => !String(o).includes('soubor'))
                )
                    .then(() => setDisableDownload(false))
                    .catch(() => setDisableDownload(true));
            },
            beforeUpload: (file: UploadFile) => {
                // kontrola maximalnej velkosti s suboru
                if ((file.size || 0) / 1024 / 1024 > 20) {
                    NotificationComponent({
                        title: 'UPLOAD_MAX_SIZE',
                        description: 'UPLOAD_MAX_SIZE_TEXT',
                        type: ENotificationType.ERROR
                    });
                    return false;
                }
                if (disableDownload) return false;
                return true;
            }
        }),
        showDownloadIcon: true,
        onChange: (data: UploadChangeParam) => {
            if (data.file.status === 'uploading' && setUploading) setUploading(true);
            if (data.file.status !== 'uploading' && setUploading) setUploading(false);
            if (data.fileList.length) {
                if (data.file.response) {
                    form.validateFields(['soubor']);
                    const prilozeneSouboryNew = data.fileList
                        .filter(f => f.status && f.status !== 'error')
                        .map(e => {
                            return {
                                orignazev: e.name.normalize(),
                                tempnazev: e.response ? e.response.tempnazev : e.fileName
                            };
                        });
                    setPrilozeneSoubory(prilozeneSouboryNew);
                    onFinish(form.getFieldsValue(), prilozeneSouboryNew);
                }
                setFileList(
                    data.fileList
                        .filter(f => f.status && f.status !== 'error')
                        .map(e => {
                            return {
                                uid: e.uid,
                                name: e.name.normalize(),
                                fileName: e.fileName ? e.fileName : e.response ? e.response.tempnazev : '',
                                type: e.type!,
                                size: e.size!,
                                status: e.status ? e.status : 'error'
                            };
                        })
                );
            }
        },
        onRemove: (file: UploadFile) => {
            if (fileList?.length) {
                const oldState = [...fileList];
                const newState = oldState.filter(e => e.uid !== file.uid);
                setFileList(newState);
                const newSoubory = [...prilozeneSoubory].filter(e => e.tempnazev !== file.fileName);
                setPrilozeneSoubory(newSoubory);
                onFinish(form.getFieldsValue(), newSoubory);
            }
        },
        onDownload: (file: UploadFile) =>
            prepareFile(file.fileName ? file.fileName : '', lei?.idVarsymZadosti?.varsym || '').then(resp => {
                fileDownload(resp.redirect, file.name ? file.name : 'file');
            }),
        fileList: fileList,
        buttonDisabled: fileList ? fileList.length > 4 : false
    };

    return (
        <>
            {typZadosti !== 'BRANCH' && language === 'cz' && (
                <>
                    <Paragraph
                        text="LEI_DETAIL_MAT_TEXT"
                        style={{
                            display: 'block',
                            marginBottom: 16
                        }}
                    />
                    <Paragraph
                        text="LEI_DETAIL_MAT_TEXT2"
                        style={{
                            display: 'block'
                        }}
                    />
                    <Paragraph
                        text="LEI_DETAIL_MAT_TEXT3"
                        style={{
                            display: 'block',
                            paddingBottom: 30
                        }}
                    />
                </>
            )}
            {language === 'en' && typZadosti !== ETypZadostiLei.BRANCH && (
                <Paragraph
                    text="LEI_DETAIL_MAT_TEXT2"
                    style={{
                        // marginTop: 12,
                        display: 'block',
                        marginBottom: 10
                    }}
                />
            )}
            {language === 'en' && typZadosti !== ETypZadostiLei.BRANCH && (
                <Paragraph
                    text="LEI_DETAIL_MAT_TEXT3"
                    style={{
                        display: 'block',
                        paddingBottom: 30
                    }}
                />
            )}
            <LoadingWrapper loading={loading} loadingText="NACITANI_DAT">
                <FormWrapper outForm={form} onFinish={onFinish}>
                    <SelectComponent
                        isFormItem={true}
                        name="stav"
                        defaultValue={
                            typZadosti === ETypZadostiLei.SOLE_PROPRIETOR
                                ? 'Nevede'
                                : internationalMatka?.length
                                  ? 'Vede'
                                  : primaMatkaData?.length
                                    ? primaMatkaData[0].stav
                                    : undefined
                        }
                        labelParagraph={
                            typZadosti === ETypZadostiLei.BRANCH
                                ? 'LEI_DETAIL_MAT_SELECT_BRANCH'
                                : 'LEI_DETAIL_MAT_SELECT'
                        }
                        data={leiMaMaterskouSpolPrimaSelect}
                        onChange={val => {
                            form.setFieldsValue({
                                duvod:
                                    typZadosti === ETypZadostiLei.SOLE_PROPRIETOR
                                        ? EMatNemaDuvod.NON_CONSOLIDATING
                                        : typZadosti === ETypZadostiLei.INTERNATIONAL_ORGANIZATION
                                          ? EMatNemaDuvod.NO_KNOWN_PERSON
                                          : typZadosti === ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY
                                            ? EMatNemaDuvod.NO_KNOWN_PERSON
                                            : undefined,
                                ...((typZadosti === ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY ||
                                    typZadosti === ETypZadostiLei.INTERNATIONAL_ORGANIZATION) &&
                                    val === EMaterskaSpol.ANO && {
                                        malei: 'ano'
                                    })
                            });
                            val === EMaterskaSpol.NE ? setShowFinalniMatka(true) : setShowFinalniMatka(false);
                            setErrorLei('');
                            setEntityCheckErr('');
                            rerender();
                        }}
                        disabled={typZadosti === ETypZadostiLei.BRANCH || typZadosti === ETypZadostiLei.SOLE_PROPRIETOR}
                        hide={typZadosti === ETypZadostiLei.BRANCH}
                    />

                    <>
                        {form.getFieldValue('stav') === EMaterskaSpol.ANO && (
                            <>
                                <SelectComponent
                                    isFormItem={true}
                                    hide={typZadosti === ETypZadostiLei.BRANCH}
                                    name="malei"
                                    defaultValue={
                                        internationalMatka?.length ||
                                        typZadosti === ETypZadostiLei.INTERNATIONAL_ORGANIZATION ||
                                        typZadosti === ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY
                                            ? 'ano'
                                            : primaMatkaData?.length
                                              ? primaMatkaData[0].matkaslei
                                                  ? 'ano'
                                                  : primaMatkaData[0].matkabezlei && 'ne'
                                              : undefined
                                    }
                                    labelParagraph={
                                        typZadosti === ETypZadostiLei.BRANCH
                                            ? 'LEI_DETAIL_MAMATKA_BRANCH'
                                            : 'LEI_DETAIL_MAMATKA'
                                    }
                                    data={anoNe}
                                    onChange={val => {
                                        rerender();
                                        val === 'ne' && setShowFinalniMatka(false);
                                        setEntityCheckErr('');
                                    }}
                                    disabled={
                                        showFinalniMatka ||
                                        (internationalMatka || []).length > 0 ||
                                        typZadosti === ETypZadostiLei.INTERNATIONAL_ORGANIZATION ||
                                        typZadosti === ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY
                                    }
                                />

                                {(form.getFieldValue('malei') === EAnoNe.ANO ||
                                    typZadosti === ETypZadostiLei.BRANCH ||
                                    typZadosti === ETypZadostiLei.INTERNATIONAL_ORGANIZATION ||
                                    typZadosti === ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY) && (
                                    <LoadingWrapper loading={leiCheckLoading} loadingText="NACITANI_DAT">
                                        <InputComponent
                                            label={
                                                typZadosti === ETypZadostiLei.BRANCH
                                                    ? 'LEI_DETAIL_MATER_SPOLOCNOSTI_BRANCH'
                                                    : 'LEI_DETAIL_MATER_SPOLOCNOSTI'
                                            }
                                            name="matkaslei"
                                            initialValue={
                                                internationalMatka?.length
                                                    ? internationalMatka[0].matkaslei
                                                    : primaMatkaData?.length
                                                      ? primaMatkaData[0].matkaslei
                                                      : undefined
                                            }
                                            rules={[
                                                ...leiValidation(async (value: string) => {
                                                    if (value !== lei?.detailData?.spolecnost?.legalentityidentifier) {
                                                        setLeiCheckLoading(true);
                                                        const resp = value
                                                            ? await checkLeiApi(value).catch(() => null)
                                                            : null;
                                                        setLeiCheckLoading(false);
                                                        form.setFieldsValue({
                                                            leinazev: resp ? resp.spolecnost : undefined
                                                        });
                                                        rerender();
                                                        if (
                                                            (typZadosti === ETypZadostiLei.INTERNATIONAL_ORGANIZATION ||
                                                                typZadosti ===
                                                                    ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY) &&
                                                            resp?.kategorie &&
                                                            resp?.kategorie !== 'RESIDENT_GOVERNMENT_ENTITY'
                                                        ) {
                                                            return setLeiCheckError('CHYBNE_LEI2');
                                                        }
                                                        if (
                                                            resp?.stavlei === 'RETIRED' ||
                                                            resp?.stavlei === 'ANNULLED' ||
                                                            resp?.stavlei === 'DUPLICATE'
                                                        ) {
                                                            return setLeiCheckError('CHYBNE_LEI');
                                                        }
                                                        if (!resp && value) {
                                                            return setLeiCheckError('LEI_CHECK_ERROR');
                                                        }
                                                        return setLeiCheckError('');
                                                    }
                                                }),
                                                () => ({
                                                    validator(_, value: string) {
                                                        if (
                                                            value === lei?.detailData?.spolecnost?.legalentityidentifier
                                                        )
                                                            return Promise.reject(
                                                                <TranslateText>LEI_MATKA_STEJNE_ERR</TranslateText>
                                                            );
                                                        if (!value || !leiCheckError) return Promise.resolve();
                                                        return Promise.reject();
                                                    }
                                                })
                                            ]}
                                            onChange={() => setLeiCheckError('')}
                                            validateTrigger={['onBlur', 'onSubmit']}
                                            validateStatus={leiCheckError ? 'error' : undefined}
                                            maxLength={20}
                                            disabled={showFinalniMatka || typZadosti === ETypZadostiLei.BRANCH}
                                            extramessage={leiCheckError}
                                        />
                                        {form.getFieldValue('leinazev') && (
                                            <InputComponent
                                                label={
                                                    typZadosti === ETypZadostiLei.BRANCH
                                                        ? 'LEI_DETAIL_MATER_NAZEV_BRANCH'
                                                        : 'LEI_DETAIL_MATER_NAZEV'
                                                }
                                                name="leinazev"
                                                placeholder=""
                                                disabled={true}
                                                initialValue={undefined}
                                                maxLength={80}
                                                notRequired={true}
                                                rules={[]}
                                            />
                                        )}
                                    </LoadingWrapper>
                                )}

                                {form.getFieldValue('malei') === EAnoNe.NE && (
                                    <>
                                        <SelectComponent
                                            isFormItem={true}
                                            name="jurisdikce"
                                            defaultValue={
                                                primaMatkaData?.length
                                                    ? primaMatkaData[0].matkabezlei?.jurisdikce
                                                    : undefined
                                            }
                                            labelParagraph="LEI_DETAIL_JURISDICKE"
                                            data={cisStaty}
                                            disabled={showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH}
                                            onChange={() => {
                                                form.setFieldsValue({
                                                    registrationauthorityid: undefined
                                                });
                                                setShowDefaultValues(pv => {
                                                    return {
                                                        ...pv,
                                                        registrationauthorityid: false
                                                    };
                                                });

                                                // form.validateFields(['registrationauthorityentityid']);
                                            }}
                                        />
                                        <SelectComponent
                                            disabled={showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH}
                                            isFormItem={true}
                                            name="registrationauthorityid"
                                            defaultValue={
                                                showDefaultValues.registrationauthorityid
                                                    ? primaMatkaData?.length
                                                        ? primaMatkaData[0].matkabezlei?.registrationauthorityid
                                                        : undefined
                                                    : undefined
                                            }
                                            labelParagraph="LEI_DETAIL_REJSTRIK"
                                            showOptionValue={true}
                                            optionValueFilter={['RA888888']}
                                            data={[
                                                ...(form.getFieldValue('jurisdikce') !== undefined &&
                                                Object.keys(leiRejstrikySelect).includes(
                                                    form.getFieldValue('jurisdikce')
                                                )
                                                    ? _getKeyValue_(form.getFieldValue('jurisdikce'))(
                                                          leiRejstrikySelect
                                                      )
                                                    : []),
                                                ...leiRejstrikyPermanent
                                            ]}
                                            onChange={val => {
                                                val === 'RA000161' &&
                                                    form.setFieldsValue({
                                                        registrationauthorityentityid: 'ΗΕ'
                                                    });
                                                rerender(true);
                                            }}
                                        />
                                        {form?.getFieldValue('registrationauthorityid') === 'RA888888' && (
                                            <InputComponent
                                                label="LEI_REJSTRIK_INY"
                                                name="otherregistrationauthorityid"
                                                initialValue={
                                                    primaMatkaData?.length
                                                        ? primaMatkaData[0].matkabezlei?.otherregistrationauthorityid
                                                        : undefined
                                                }
                                                maxLength={80}
                                                disabled={showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH}
                                            />
                                        )}

                                        <InputComponent
                                            label="LEI_DETAIL_IDMAT"
                                            name="registrationauthorityentityid"
                                            initialValue={
                                                primaMatkaData?.length
                                                    ? primaMatkaData[0].matkabezlei?.registrationauthorityentityid
                                                    : undefined
                                            }
                                            rules={leiRejstrikValidation(form.getFieldValue('registrationauthorityid'))}
                                            disabled={showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH}
                                            maxLength={30}
                                        />
                                    </>
                                )}
                                {form.getFieldValue('malei') && form.getFieldValue('malei') !== EAnoNe.NE && (
                                    <>
                                        <DatePickerComponent
                                            label="LEI_DETAIL_MATKA_DATUM"
                                            name="relationship"
                                            initialValue={
                                                primaMatkaDates && primaMatkaDates.relationship
                                                    ? primaMatkaDates.relationship.startdate &&
                                                      dayjs(primaMatkaDates.relationship.startdate)
                                                    : undefined
                                            }
                                            disabledDate={curr => curr > dayjs()}
                                            disabled={showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH}
                                        />
                                        <InputNumberComponent
                                            label="LEI_DETAIL_MATKA_PODIL"
                                            name="podilspolecnosti"
                                            initialValue={
                                                primaMatkaData?.length
                                                    ? primaMatkaData[0].informacekmatce?.podilspolecnosti
                                                    : undefined
                                            }
                                            disabled={showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH}
                                            rules={procentaValidation()}
                                            maxLength={8}
                                        />
                                        <SelectComponent
                                            isFormItem={true}
                                            name="konsolidace"
                                            defaultValue={
                                                primaMatkaData?.length
                                                    ? primaMatkaData[0].informacekmatce?.konsolidace
                                                    : undefined
                                            }
                                            disabled={showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH}
                                            labelParagraph="LEI_DETAIL_MATKA_KONSOLIDACE"
                                            data={
                                                typZadosti === ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY
                                                    ? leiKonsolidaceTypSelectAltGov
                                                    : typZadosti === ETypZadostiLei.INTERNATIONAL_ORGANIZATION
                                                      ? leiKonsolidaceTypSelectAlt
                                                      : leiKonsolidaceTypSelect
                                            }
                                        />

                                        <Form.Item
                                            name="soubor"
                                            label={
                                                <Paragraph
                                                    text={language === 'en' ? 'LEI_DETAIL_UPLOAD' : 'SOUBOR'}
                                                    strong={true}
                                                />
                                            }
                                            rules={[
                                                {
                                                    required: true,
                                                    validator() {
                                                        try {
                                                            if (!fileList || fileList.length < 1)
                                                                return Promise.reject(
                                                                    <TranslateText>
                                                                        NEVALIDNI_POVINNA_POLOZKA_UPLOAD
                                                                    </TranslateText>
                                                                );
                                                            return Promise.resolve();
                                                        } catch {
                                                            return Promise.reject();
                                                        }
                                                    }
                                                }
                                            ]}
                                        >
                                            <div
                                                style={{
                                                    marginBottom: 22
                                                }}
                                            >
                                                {language !== 'en' && (
                                                    <p>
                                                        <TranslateText>LEI_VLOZTE_MAT</TranslateText>
                                                    </p>
                                                )}
                                                <UploadComponent
                                                    id="primaMatUploadBtn"
                                                    {...uploadProps}
                                                    disabled={showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH}
                                                    accept={'.pdf, .rtf, .docx, .doc'}
                                                />
                                            </div>
                                        </Form.Item>
                                        {(fileList || []).length > 0 && (
                                            <>
                                                <SelectComponent
                                                    isFormItem={true}
                                                    name="validationdocuments"
                                                    defaultValue={
                                                        primaMatkaData?.length
                                                            ? primaMatkaData[0].informacekmatce?.validationdocuments
                                                            : undefined
                                                    }
                                                    labelParagraph="LEI_DETAIL_MATKA_KONSOLIDACE_CONFIRM"
                                                    data={leiKonsolidaceSouborySelect}
                                                    onChange={() => rerender()}
                                                    disabled={showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH}
                                                />
                                                {form.getFieldValue('validationdocuments') ===
                                                    ETypDatMatky.REGULATORY_FILING && (
                                                    <InputComponent
                                                        label="LEI_DETAIL_REGULATORY"
                                                        name="validationreference"
                                                        initialValue={
                                                            primaMatkaData?.length
                                                                ? primaMatkaData[0].informacekmatce?.validationreference
                                                                : undefined
                                                        }
                                                        disabled={
                                                            showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH
                                                        }
                                                    />
                                                )}
                                                {form.getFieldValue('validationdocuments') && (
                                                    <>
                                                        {/* PRI ZMENE TYCHTO 4 PICKROV NEZABUDNUT ZMENIT AJ V PREHLADE */}
                                                        <DatePickerComponent
                                                            disabledDate={current =>
                                                                form.getFieldValue('accountingend') &&
                                                                current >
                                                                    dayjs(form.getFieldValue('accountingend')).subtract(
                                                                        1,
                                                                        'days'
                                                                    )
                                                            }
                                                            label="LEI_DETAIL_UCETNI_OBDOBY_OD"
                                                            name="accountingstart"
                                                            initialValue={
                                                                primaMatkaDates && primaMatkaDates.accounting
                                                                    ? dayjs(primaMatkaDates.accounting.startdate)
                                                                    : undefined
                                                            }
                                                            disabled={
                                                                showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH
                                                            }
                                                        />
                                                        <DatePickerComponent
                                                            disabledDate={current =>
                                                                form.getFieldValue('accountingstart') &&
                                                                current <
                                                                    dayjs(form.getFieldValue('accountingstart')).add(
                                                                        1,
                                                                        'days'
                                                                    )
                                                            }
                                                            label="LEI_DETAIL_UCETNI_OBDOBY_DO"
                                                            name="accountingend"
                                                            notRequired={
                                                                form.getFieldValue('validationdocuments') !==
                                                                    ETypDatMatky.ACCOUNTS_FILING &&
                                                                form.getFieldValue('validationdocuments') !==
                                                                    ETypDatMatky.REGULATORY_FILING
                                                            }
                                                            initialValue={
                                                                primaMatkaDates && primaMatkaDates.accounting
                                                                    ? primaMatkaDates.accounting.enddate &&
                                                                      dayjs(primaMatkaDates.accounting.enddate)
                                                                    : undefined
                                                            }
                                                            disabled={
                                                                showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH
                                                            }
                                                        />
                                                    </>
                                                )}
                                                {form.getFieldValue('validationdocuments') &&
                                                    form.getFieldValue('validationdocuments') !==
                                                        ETypDatMatky.ACCOUNTS_FILING && (
                                                        <>
                                                            <DatePickerComponent
                                                                disabledDate={current =>
                                                                    form.getFieldValue('documentend') &&
                                                                    current >
                                                                        dayjs(
                                                                            form.getFieldValue('documentend')
                                                                        ).subtract(1, 'days')
                                                                }
                                                                label="LEI_DETAIL_PLATNOSTDOKUMENTU_OD"
                                                                name="documentstart"
                                                                initialValue={
                                                                    primaMatkaDates && primaMatkaDates.document
                                                                        ? dayjs(primaMatkaDates.document.startdate)
                                                                        : undefined
                                                                }
                                                                disabled={
                                                                    showFinalniMatka &&
                                                                    typZadosti !== ETypZadostiLei.BRANCH
                                                                }
                                                            />
                                                            <DatePickerComponent
                                                                disabledDate={current =>
                                                                    form.getFieldValue('documentstart') &&
                                                                    current <
                                                                        dayjs(form.getFieldValue('documentstart')).add(
                                                                            1,
                                                                            'days'
                                                                        )
                                                                }
                                                                label="LEI_DETAIL_PLATNOSTDOKUMENTU_DO"
                                                                name="documentend"
                                                                notRequired={true}
                                                                initialValue={
                                                                    primaMatkaDates && primaMatkaDates.document?.enddate
                                                                        ? dayjs(primaMatkaDates.document.enddate)
                                                                        : undefined
                                                                }
                                                                disabled={
                                                                    showFinalniMatka &&
                                                                    typZadosti !== ETypZadostiLei.BRANCH
                                                                }
                                                            />
                                                        </>
                                                    )}
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                        {form.getFieldValue('stav') === EMaterskaSpol.NE && (
                            <>
                                <SelectComponent
                                    isFormItem={true}
                                    name="duvod"
                                    labelParagraph="LEI_DETAIL_DUVOD_SELECT"
                                    data={
                                        typZadosti === 'FUND'
                                            ? [
                                                  {
                                                      labelcz: 'NON_CONSOLIDATING',
                                                      value: EMatNemaDuvod.NON_CONSOLIDATING
                                                  }
                                              ]
                                            : leiMatNemaDuvodSelect
                                    }
                                    disabled={
                                        typZadosti === ETypZadostiLei.SOLE_PROPRIETOR ||
                                        typZadosti === ETypZadostiLei.INTERNATIONAL_ORGANIZATION ||
                                        typZadosti === ETypZadostiLei.RESIDENT_GOVERNMENT_ENTITY
                                    }
                                    onChange={val => {
                                        rerender();
                                        form.setFieldsValue({
                                            duvod: val
                                        });
                                    }}
                                />
                                {form.getFieldValue('duvod') !== EMatNemaDuvod.NON_CONSOLIDATING && (
                                    <Paragraph
                                        text="LEI_DETAIL_NE_TEXT"
                                        style={{
                                            display: 'block',
                                            marginBottom: 16,
                                            fontSize: 13
                                        }}
                                    />
                                )}
                                <Paragraph
                                    text="LEI_DETAIL_NE_TEXT2"
                                    style={{
                                        display: 'block',
                                        marginBottom: 26,
                                        fontSize: 13
                                    }}
                                />
                            </>
                        )}
                        {form.getFieldValue('stav') === EMaterskaSpol.NELZE_UVEST && (
                            <>
                                <SelectComponent
                                    isFormItem={true}
                                    name="duvod"
                                    labelParagraph="LEI_DETAIL_DUVOD_SELECT"
                                    data={leiMatNelzeDuvodSelect}
                                    //  disabled={showFinalniMatka && typZadosti !== ETypZadostiLei.BRANCH}
                                />

                                <InputTextArea
                                    rows={4}
                                    name="exceptionreference"
                                    initialValue={
                                        primaMatkaData?.length ? primaMatkaData[0].exceptionreference : undefined
                                    }
                                    label="LEI_DETAIL_NELZEUVEST_INPUT"
                                    maxLength={1000}
                                />
                            </>
                        )}
                    </>
                </FormWrapper>
                {(showFinalniMatka || form.getFieldValue('stav') === EMaterskaSpol.NE) &&
                typZadosti !== ETypZadostiLei.BRANCH ? (
                    <div id="finalniMatka">
                        <Title level={4} text="LEI_FINAL_TITLE" />
                        <FinalniMatka
                            cisStaty={cisStaty}
                            prevStep={prevStep}
                            setFinalniMatSubmitdata={setFinalniMatSubmitdata}
                            showFinalniMatka={showFinalniMatka}
                            typZadosti={typZadosti}
                            finalniMatkaData={finalniMatkaData}
                            primaMatkaFilelist={fileList}
                            primaMatkaPrilozeneSoubory={prilozeneSoubory}
                            primaMatkaForm={form}
                            rerenderVal={rerenderVal}
                            disabled={
                                form.getFieldValue('stav') === EMaterskaSpol.NE &&
                                form.getFieldValue('duvod') !== 'NON_PUBLIC'
                            }
                            entityCheckErr={entityCheckErr}
                            loading={loading}
                            setShowFinalniMatka={setShowFinalniMatka}
                            setFormData={setFormData}
                            errorLei={errorLei}
                            setErrorLei={setErrorLei}
                            setEntityCheckErr={setEntityCheckErr}
                        />
                    </div>
                ) : null}

                {(!(showFinalniMatka || form.getFieldValue('stav') === EMaterskaSpol.NE) ||
                    typZadosti === ETypZadostiLei.BRANCH) && (
                    <Row className="button-row">
                        <ButtonComponent
                            onClick={() => prevStep()}
                            buttontext="ZPET"
                            type="default"
                            id="primaMatZpetBtn"
                        />
                        <ButtonComponent
                            id="primaMatSubmitBtn"
                            type="primary"
                            onClick={() => form.submit()}
                            loading={leiCheckLoading || uploading}
                            buttontext="POKRACOVAT"
                            extramessage={
                                entityCheckErr === 'existuje'
                                    ? ((
                                          <TranslateText params={[errorLei ? ` - ${errorLei}` : '']}>
                                              LEI_ENTITYCHECK_ERR
                                          </TranslateText>
                                      ) as unknown as string)
                                    : entityCheckErr === 'shodneico'
                                      ? 'LEI_ENTITYSHODNE_ERR'
                                      : ''
                            }
                        />
                    </Row>
                )}
            </LoadingWrapper>
        </>
    );
};

export default PrimaMatka;
